import { STAGE_ORDER, type FunnelStage } from "./funnel-draft";

export function ProgressLabel({ stage }: { stage: FunnelStage }) {
  const current = Math.max(STAGE_ORDER.indexOf(stage) + 1, 1);
  const progress = Math.round((current / 5) * 100);

  return (
    <div className="mb-8">
      <div className="mb-2 flex items-center justify-between text-xs font-bold uppercase tracking-[0.18em] text-funnel-muted">
        <span>Travel preferences</span>
        <span>{current} of 5</span>
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-funnel-ink/10" role="progressbar" aria-valuemin={1} aria-valuemax={5} aria-valuenow={current} aria-label={`Travel preferences, step ${current} of 5`}>
        <div className="h-full rounded-full bg-funnel-coral transition-all" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}
